/*
 * @Author: Src
 * @Date: 2024-07-16 14:09:28
 * @LastEditTime: 2025-08-08 13:35:31
 * @LastEditors: Src
 * @FilePath: /mobile-station/src/config.ts
 * @Description: 头部注释配置模板
 */
import dev from './config/config.test';
import prod from './config/config.production';
import local from './config/config.local';

let config: {
  API_URL?: string;
  CAR_URL?: string;
  BACKEND_URL?: string;
} = {};
if (process.env.NODE_ENV === 'development') {
  config = dev;
} else if (process.env.NODE_ENV === 'production') {
  config = prod;
} else {
  config = local;
}

export default {
  ...config,
  isProd: process.env.NODE_ENV === 'production',
};
